import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1068px;
  margin: 0 auto;
`;

export const InstitutionsBox = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  span {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.09;
    letter-spacing: normal;
    text-align: center;
    color: #707070;
    display: block;
    margin: 30px 0;
  }
`;

export const InstitutionsBrands = styled.div`
  display: inline-grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
  background-color: #fff;
  color: #444;
  div {
    color: #fff;
    /* border: 1px solid #ccc; */
    padding: 5px;
    object-fit: contain;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const FooterAns = styled.div`
  margin-top: 30px;
  height: 38px;
  background-image: linear-gradient(to bottom, #3f8da1, #0a728a);
  div.container-footer {
    height: 38px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      font-size: 9.7px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.13;
      letter-spacing: normal;
      color: #aedae5;
    }
    span {
      font-size: 9.6px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      color: #aedae5;
      position: relative;
      svg {
        font-size: 13px;
        position: absolute;
        left: -20px;
      }
      a {
        color: #aedae5;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;
